<template>
  <table-layout title="انبار">
    <template #buttons>
      <b-row>


        <router-link class="ml-2 mt-1" :to="{ name: 'TrashProduct' }">
          <b-button pill variant="danger"> سطل زباله</b-button>
        </router-link>


        <b-btn pill variant="info" class="ml-2" v-b-toggle.filters>
          فیلترها
        </b-btn>

        <b-button v-b-modal.quick-create-product pill variant="purple" class="ml-2">ساخت محصول سریع</b-button>

        <b-modal id="quick-create-product" size="xl" hide-footer>
          <div class="text-right" dir="rtl">
            <create-product-layout v-if="createQuickProductForm" @refreshComponent="refreshComponent"
                                   :short-create-form="true"
                                   :submit-function="createProduct"/>
          </div>
        </b-modal>

        <LanguageSelectBox @changeLanguage="getItems" module-name="product" class="mx-4"/>

      </b-row>

    </template>
    <template #filters>
      <filters/>


    </template>

    <template #table>
      <table-items :items="products" :restoreState="false"/>
      <b-row class="pt-3 mt-3">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </b-row>
    </template>


  </table-layout>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TableLayout from "../../dashboard/TableLayout.vue";
import tableItems from "./tableItems.vue";
import Pagination from "../../dashboard/Pagination.vue";
import Filters from "../../dashboard/product/Filters";
import LanguageSelectBox from "../../dashboard/Language/LanguageSelectBox";
import CreateProductLayout from "../../dashboard/product/CreateLayout";

export default {
  name: "TableProduct",
  components: {TableLayout, tableItems, Pagination, Filters, LanguageSelectBox, CreateProductLayout},
  data() {
    return {
      createQuickProductForm: true,
    }
  },
  computed: {
    ...mapGetters({
      products: "Product/getProducts",
      paginationMeta: "Product/getPaginationMeta",
    }),
  },
  async mounted() {
    await this.getItems();
  },
  methods: {
    ...mapActions({
      createProduct: "Product/createProduct"
    }),
    changePage(page) {
      const currentRouteQuery = this.$route.query
      this.$router.push({name: this.$route.name, query: {...currentRouteQuery, ...{page: page}}})
      this.$store.dispatch("Product/setDashboardProducts", page);
    },
    async getItems() {
      let page = 1
      if (this.$route.query.page != undefined) {
        page = this.$route.query.page;
      }
      this.$store.commit("Product/setFilters", {key: "sort", value: 'id,desc'});
      await this.$store.dispatch("Product/setDashboardProducts", page);
    },
    refreshComponent() {
      this.createQuickProductForm = false
      setTimeout(() => {
        this.createQuickProductForm = true
      }, 1)

    }
  }
};
</script>